export default "/images/coopforsikringer.png?1df683f0c90b3115df38d8de8466ea11";